//General
export const ERROR = 'ERROR';

//Login Actions
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

//Sign Up Actions
export const SIGN_UP = 'SIGN_UP';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';

//Forgot Password Actions
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

//Reset Password Actions
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

//Email Verification Actions
export const EMAIL_VERIFICATION = 'EMAIL_VERIFICATION';
export const RESEND_EMAIL_VERIFICATION = 'RESEND_EMAIL_VERIFICATION';

//Profile Actions
export const CREATE_PROFILE = 'CREATE_PROFILE';
export const GET_PROFILE = 'GET_PROFILE';

//POSSIBLY REMOVE THESE 2
export const LOGGING_OUT = 'LOGGING_OUT';
export const LOGGED_OUT = 'LOGGED_OUT';

//Quote Actions
export const CREATE_QUOTE = 'CREATE_QUOTE';
export const GET_QUOTE = 'GET_QUOTE';
export const SHARE_QUOTE = 'SHARE_QUOTE';

export const CREATED_QUOTE = 'CREATED_QUOTE';
export const SELECTED_TERMS = 'SELECTED_TERMS';
export const PREVIEW_QUOTE = 'PREVIEW_QUOTE';
export const QUOTE_NAV_BACK = 'NAV_BACK_CLICKED';
export const SEND_QUOTE_TO_CUSTOMER = 'SEND_QUOTE_TO_CUSTOMER';
export const QUOTE_SENT = 'QUOTE_SENT';
export const CANCELED_QUOTE = 'CANCELED_QUOTE';
export const ERROR_SENDING_QUOTE = 'ERROR_SAVING_QUOTE';
export const ERROR_CREATING_QUOTE = 'ERROR_CREATING_QUOTE';

//Credit Actions
export const GO_TO_NEXT_CREDIT_STEP = 'GO_TO_NEXT_CREDIT_STEP';
export const SEND_CREDIT_APP = 'SEND_CREDIT_APPLICATION';

//Portfolio Actions
export const GET_PORTFOLIO = 'GET_PORTFOLIO';
export const GET_LEASE = 'GET_LEASE';
export const GET_CREDIT_APP = 'GET_CREDIT_APP';

//Notifications
export const NOTIFY_CLOSE = 'NOTIFY_CLOSE';
export const NOTIFY_NEW = 'NOTIFY_NEW';



// WEBPACK FOOTER //
// ./src/utils/ActionConstants.js